import React from 'react'
import PropTypes from 'prop-types'
import { useField, ErrorMessage } from 'formik'

// Shared Styled Elements
import { Wrapper, FormLabel, FormErrorMessage } from '../SharedStyles.element'

// Styled Elements
import { FormFieldInput } from './FormFileField.elements'

function FormFileField(props) {
  // Destructure
  const { label, disabled, ...rest } = props

  // Hooks
  const [fields] = useField(props)

  return (
    <Wrapper label={label}>
      {label && <FormLabel disabled={disabled}>{label}</FormLabel>}
      <FormFieldInput disabled={disabled} type="file" {...fields} {...rest} />
      <FormErrorMessage>
        <ErrorMessage {...fields} />
      </FormErrorMessage>
    </Wrapper>
  )
}

// Default Props
FormFileField.defaultProps = {
  type: '',
  label: '',
  disabled: false,
}

// Proptypes Validation
FormFileField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FormFileField
